export const indexItems = [
  { id: 'idx-1', title: '动作大片', icon: 'ri-sword-line', description: '热血刺激动作巨制合集', count: '2,380部' },
  { id: 'idx-2', title: '喜剧精选', icon: 'ri-emotion-laugh-line', description: '欢乐爆笑经典喜剧', count: '1,620部' },
  { id: 'idx-3', title: '悬疑推理', icon: 'ri-search-eye-line', description: '烧脑高能反转神作', count: '980部' },
  { id: 'idx-4', title: '爱情文艺', icon: 'ri-heart-line', description: '动人浪漫情感故事', count: '1,350部' },
  { id: 'idx-5', title: '科幻巨制', icon: 'ri-rocket-line', description: '震撼视效未来世界', count: '760部' },
  { id: 'idx-6', title: '恐怖惊悚', icon: 'ri-ghost-line', description: '胆量挑战极限恐怖', count: '640部' },
  { id: 'idx-7', title: '动漫番剧', icon: 'ri-tv-line', description: '热门连载与经典番剧', count: '2,100部' },
  { id: 'idx-8', title: '纪录纪实', icon: 'ri-camera-line', description: '真实世界深度观察', count: '520部' },
];

export const carouselItems = [
  {
    id: 'car-1',
    title: '暑期档动作巨制震撼来袭',
    description: '多部好莱坞与国产动作大片同步上线蓝光画质，每一帧都是视觉盛宴',
    tag: '热门推荐',
    image: 'https://readdy.ai/api/search-image?query=Epic%20action%20movie%20poster%20style%20with%20dramatic%20lighting%2C%20warrior%20silhouette%20against%20burning%20cityscape%2C%20cinematic%20composition%2C%20warm%20orange%20and%20crimson%20tones%2C%20film%20grain%20texture%2C%20clean%20simple%20dark%20background&width=700&height=440&seq=carousel-01-cq&orientation=landscape',
  },
  {
    id: 'car-2',
    title: '悬疑剧场：烧脑神作连播',
    description: '精选全网高分悬疑电影和电视剧，反转不断让你欲罢不能',
    tag: '编辑精选',
    image: 'https://readdy.ai/api/search-image?query=Suspense%20thriller%20film%20visual%2C%20shadowy%20figure%20in%20rain%20soaked%20street%2C%20moody%20atmospheric%20lighting%2C%20noir%20aesthetic%2C%20deep%20contrast%2C%20cinematic%20tension%2C%20dark%20muted%20tones&width=700&height=440&seq=carousel-02-cq&orientation=landscape',
  },
  {
    id: 'car-3',
    title: '浪漫爱情片合集温情上线',
    description: '从经典老片到最新热映，感受光影中流转的深情与温暖',
    tag: '新片上线',
    image: 'https://readdy.ai/api/search-image?query=Romantic%20drama%20film%20visual%20with%20couple%20silhouette%20at%20sunset%2C%20soft%20golden%20hour%20lighting%2C%20dreamy%20atmosphere%2C%20warm%20amber%20tones%2C%20cinematic%20widescreen%20aspect%20ratio%2C%20clean%20background&width=700&height=440&seq=carousel-03-cq&orientation=landscape',
  },
  {
    id: 'car-4',
    title: '科幻迷专属频道全面升级',
    description: '高清修复经典科幻大片，更有最新视效巨制等你探索无限宇宙',
    tag: '高清修复',
    image: 'https://readdy.ai/api/search-image?query=Science%20fiction%20movie%20poster%20aesthetic%2C%20futuristic%20city%20skyline%20at%20night%2C%20neon%20reflections%2C%20deep%20space%20background%2C%20cosmic%20nebula%2C%20sleek%20modern%20design%2C%20dark%20tech%20atmosphere&width=700&height=440&seq=carousel-04-cq&orientation=landscape',
  },
  {
    id: 'car-5',
    title: '国漫崛起：精品动画大赏',
    description: '汇聚近年国产动画优秀作品，画风精美故事动人，支持蓝光画质',
    tag: '国漫专区',
    image: 'https://readdy.ai/api/search-image?query=Animated%20fantasy%20film%20poster%20style%2C%20enchanted%20forest%20with%20glowing%20elements%2C%20magical%20particles%2C%20warm%20ethereal%20lighting%2C%20whimsical%20and%20dreamy%20atmosphere%2C%20soft%20pastel%20color%20palette&width=700&height=440&seq=carousel-05-cq&orientation=landscape',
  },
];

export const commentItems = [
  {
    id: 'cmt-1',
    author: '追剧达人小王',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20young%20Chinese%20man%20with%20glasses%2C%20friendly%20expression%2C%20clean%20simple%20warm%20background%2C%20professional%20headshot%20style&width=80&height=80&seq=avatar-01-cq&orientation=squarish',
    content: '用了成全影院快一年了，画质真的没话说。蓝光片源加载速度超快，关键是完全没有广告，追剧体验太舒服了。',
    rating: 5,
    date: '2026-07-28',
    watched: '《流浪地球3》',
  },
  {
    id: 'cmt-2',
    author: '电影爱好者老张',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20middle%20aged%20Chinese%20man%2C%20warm%20smile%2C%20casual%20style%2C%20clean%20simple%20warm%20background%2C%20natural%20headshot&width=80&height=80&seq=avatar-02-cq&orientation=squarish',
    content: '作为一个老影迷，收藏了不少冷门好片在这里找到了高清版本。资源更新也很快，新片基本同步上线。',
    rating: 5,
    date: '2026-07-25',
    watched: '《奥本海默》',
  },
  {
    id: 'cmt-3',
    author: '深夜追剧人小李',
    avatar: 'https://readdy.ai/api/search-image?query=Portrait%20of%20young%20Chinese%20woman%20with%20long%20hair%2C%20gentle%20smile%2C%20clean%20simple%20warm%20background%2C%20natural%20headshot%20style&width=80&height=80&seq=avatar-03-cq&orientation=squarish',
    content: '最喜欢的就是不卡顿这一点，之前用别的平台看剧经常缓冲，成全影院真的流畅到飞起。推荐给所有追剧的朋友了！',
    rating: 5,
    date: '2026-07-22',
    watched: '《繁花》',
  },
];

export const faqItems = [
  {
    id: 'faq-1',
    question: '成全影院的影片都是高清画质吗？',
    answer: '是的，成全影院所有影片均提供高清画质播放，部分热门影片支持蓝光画质。我们采用先进的视频压缩与传输技术，确保画质清晰的同时保证播放流畅不卡顿。',
  },
  {
    id: 'faq-2',
    question: '观看影片需要付费或注册吗？',
    answer: '完全不需要。成全影院承诺永久免费在线观看，无需注册、无需登录、无需付费。我们通过合理的运营方式维持平台运转，用户享受无广告干扰的纯净观影体验。',
  },
  {
    id: 'faq-3',
    question: '为什么成全影院播放不卡顿？',
    answer: '我们自建了分布式CDN加速网络，在全国范围内部署了多个节点服务器，并采用了智能码率自适应技术，能根据您的网络环境自动匹配最优画质，确保流畅播放体验。',
  },
  {
    id: 'faq-4',
    question: '影片资源多久更新一次？',
    answer: '成全影院的内容团队每日更新影片资源，院线新片下映后第一时间上线高清版本，热门电视剧同步跟播，综艺节目、纪录片等品类也保持高频更新，确保您不错过任何精彩内容。',
  },
];

export const updateItems = [
  { id: 'upd-1', title: '《流浪地球3》蓝光版本正式上线', date: '2026-07-31', tag: '新片上线' },
  { id: 'upd-2', title: '暑期档专题「盛夏光影季」活动开启', date: '2026-07-30', tag: '专题活动' },
  { id: 'upd-3', title: '平台新增4K超清专区，百部大片已适配', date: '2026-07-28', tag: '功能升级' },
  { id: 'upd-4', title: '《繁花》全集完整版无删减上线', date: '2026-07-26', tag: '剧集更新' },
  { id: 'upd-5', title: '纪录片频道新增BBC经典系列30部', date: '2026-07-24', tag: '内容扩充' },
  { id: 'upd-6', title: '移动端观影体验全面优化升级', date: '2026-07-22', tag: '体验优化' },
  { id: 'upd-7', title: '韩剧专区上线，热门韩剧同步跟播中', date: '2026-07-20', tag: '新频道' },
];

export const topicItems = [
  { id: 'tpc-1', name: '流浪地球3', heat: '980万', trend: 'up' },
  { id: 'tpc-2', name: '繁花', heat: '850万', trend: 'up' },
  { id: 'tpc-3', name: '奥本海默', heat: '720万', trend: 'stable' },
  { id: 'tpc-4', name: '封神第二部', heat: '680万', trend: 'up' },
  { id: 'tpc-5', name: '国漫崛起', heat: '590万', trend: 'up' },
  { id: 'tpc-6', name: '悬疑剧场', heat: '520万', trend: 'stable' },
  { id: 'tpc-7', name: '暑期档', heat: '480万', trend: 'hot' },
  { id: 'tpc-8', name: '经典港片', heat: '410万', trend: 'stable' },
  { id: 'tpc-9', name: '科幻巨制', heat: '370万', trend: 'up' },
];

export const rankingItems = [
  { id: 'rnk-1', rank: 1, title: '流浪地球3', category: '科幻 / 冒险', score: '9.6', tag: '热播中' },
  { id: 'rnk-2', rank: 2, title: '繁花', category: '剧情 / 年代', score: '9.4', tag: '全集上线' },
  { id: 'rnk-3', rank: 3, title: '封神第二部', category: '奇幻 / 史诗', score: '9.3', tag: '新上线' },
  { id: 'rnk-4', rank: 4, title: '奥本海默', category: '传记 / 历史', score: '9.5', tag: '蓝光画质' },
  { id: 'rnk-5', rank: 5, title: '孤注一掷', category: '犯罪 / 剧情', score: '9.1', tag: '热门推荐' },
];

export const cardItems = [
  {
    id: 'crd-1',
    title: '国产科幻崛起之路',
    description: '从《流浪地球》系列到最新力作，国产科幻电影正以惊人的速度追赶好莱坞。成全影院为你整理国产科幻电影全收录，蓝光画质重温每一个震撼瞬间。',
    tag: '深度专题',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20sci%20fi%20movie%20theme%2C%20futuristic%20space%20station%20with%20Earth%20in%20background%2C%20dramatic%20cinematic%20lighting%2C%20warm%20orange%20and%20dark%20blue%20contrast%2C%20epic%20scale%2C%20clean%20composition&width=700&height=440&seq=cards-01-cq&orientation=landscape',
  },
  {
    id: 'crd-2',
    title: '王家卫电影美学赏析',
    description: '从《花样年华》到《繁花》，王家卫独特的视觉语言影响了一代人。成全影院高清修复版本，带你重新发现光影中的诗意与孤独。',
    tag: '导演专题',
    image: 'https://readdy.ai/api/search-image?query=Wong%20Kar%20wai%20film%20aesthetic%2C%20nostalgic%20Hong%20Kong%20alley%20with%20warm%20neon%20lights%2C%20rain%20slicked%20streets%2C%20cinematic%20color%20grading%2C%20dreamy%20atmosphere%2C%20vintage%20style&width=700&height=440&seq=cards-02-cq&orientation=landscape',
  },
  {
    id: 'crd-3',
    title: '暑期亲子观影指南',
    description: '暑假过半，成全影院精选适合全家一起观看的优秀影片。动画、冒险、喜剧一应俱全，让亲子时光在欢笑与感动中度过。',
    tag: '主题策划',
    image: 'https://readdy.ai/api/search-image?query=Family%20movie%20night%20theme%2C%20cozy%20living%20room%20with%20large%20TV%20screen%2C%20warm%20ambient%20lighting%2C%20comfortable%20atmosphere%2C%20soft%20golden%20tones%2C%20happy%20family%20vibe%2C%20clean%20modern%20style&width=700&height=440&seq=cards-03-cq&orientation=landscape',
  },
  {
    id: 'crd-4',
    title: '韩剧爆款追剧日历',
    description: '2026年韩剧市场佳作频出，成全影院同步跟播多部热门韩剧。从浪漫爱情到悬疑犯罪，一份追剧日历帮你安排好每一部必看之作。',
    tag: '追剧指南',
    image: 'https://readdy.ai/api/search-image?query=Korean%20drama%20aesthetic%2C%20elegant%20romantic%20scene%20with%20cherry%20blossoms%2C%20soft%20pastel%20warm%20lighting%2C%20cinematic%20composition%2C%20dreamy%20atmosphere%2C%20clean%20minimal%20background&width=700&height=440&seq=cards-04-cq&orientation=landscape',
  },
  {
    id: 'crd-5',
    title: '经典港片高清修复计划',
    description: '成全影院正在逐步修复经典香港电影的高清版本。从周星驰喜剧到杜琪峰黑帮片，那些陪伴我们成长的港片如今以全新画质回归。',
    tag: '经典修复',
    image: 'https://readdy.ai/api/search-image?query=Classic%20Hong%20Kong%20cinema%20theme%2C%20old%20Hong%20Kong%20street%20scene%20with%20vintage%20neon%20signs%2C%20warm%20golden%20nostalgic%20lighting%2C%20film%20grain%20texture%2C%20cinematic%20retro%20aesthetic&width=700&height=440&seq=cards-05-cq&orientation=landscape',
  },
];

export const mediaItems = [
  {
    id: 'med-1',
    title: '流浪地球3',
    description: '人类命运共同体的终极之战，视觉特效再度突破国产科幻天花板',
    duration: '148分钟',
    category: '科幻 / 冒险',
    image: 'https://readdy.ai/api/search-image?query=Epic%20space%20adventure%20film%20poster%2C%20astronaut%20facing%20massive%20planet%2C%20dramatic%20cinematic%20lighting%2C%20deep%20space%20background%20with%20stars%2C%20warm%20golden%20rim%20light%2C%20dark%20atmosphere&width=700&height=440&seq=media-01-cq&orientation=landscape',
  },
  {
    id: 'med-2',
    title: '繁花',
    description: '王家卫首部电视剧，讲述上海九十年代商海沉浮与人间烟火',
    duration: '30集',
    category: '剧情 / 年代',
    image: 'https://readdy.ai/api/search-image?query=Shanghai%201990s%20nostalgic%20street%20scene%2C%20warm%20golden%20evening%20light%2C%20elegant%20vintage%20aesthetic%2C%20cinematic%20color%20grading%2C%20soft%20bokeh%20lights%2C%20romantic%20atmosphere&width=700&height=440&seq=media-02-cq&orientation=landscape',
  },
  {
    id: 'med-3',
    title: '封神第二部',
    description: '东方神话史诗续作，神仙斗法特效炸裂，影院级视听盛宴',
    duration: '156分钟',
    category: '奇幻 / 史诗',
    image: 'https://readdy.ai/api/search-image?query=Chinese%20mythology%20epic%20film%20poster%2C%20ancient%20Chinese%20warriors%20in%20dramatic%20battle%2C%20golden%20and%20crimson%20tones%2C%20epic%20scale%20with%20clouds%20and%20mountains%2C%20cinematic%20grandeur&width=700&height=440&seq=media-03-cq&orientation=landscape',
  },
  {
    id: 'med-4',
    title: '奥本海默',
    description: '诺兰执导原子弹之父传记片，IMAX摄影打造震撼人心的人类史诗',
    duration: '180分钟',
    category: '传记 / 历史',
    image: 'https://readdy.ai/api/search-image?query=Historical%20drama%20film%20poster%20style%2C%20black%20and%20white%20cinematic%20portrait%20with%20dramatic%20shadows%2C%20intense%20lighting%2C%20serious%20atmosphere%2C%20Nolan%20film%20aesthetic&width=700&height=440&seq=media-04-cq&orientation=landscape',
  },
  {
    id: 'med-5',
    title: '孤注一掷',
    description: '揭露跨国网络诈骗内幕的现实主义力作，高能反转全程无尿点',
    duration: '130分钟',
    category: '犯罪 / 剧情',
    image: 'https://readdy.ai/api/search-image?query=Crime%20thriller%20film%20poster%20aesthetic%2C%20dark%20urban%20night%20scene%20with%20neon%20reflections%2C%20tense%20atmosphere%2C%20dramatic%20contrast%20lighting%2C%20modern%20Asian%20cityscape&width=700&height=440&seq=media-05-cq&orientation=landscape',
  },
];

export const featureItems = [
  {
    id: 'feat-1',
    title: '蓝光画质 流畅不卡顿',
    description: '采用分布式CDN加速与智能码率自适应技术，无论宽带还是移动网络，都能享受蓝光画质的流畅观影体验，告别缓冲等待。',
    icon: 'ri-4k-line',
  },
  {
    id: 'feat-2',
    title: '完全免费 无广告干扰',
    description: '成全影院坚持永久免费在线观看，不设置任何付费墙。观影全程无弹窗广告、无贴片广告、无插播广告，还原纯净观影体验。',
    icon: 'ri-vip-crown-line',
  },
  {
    id: 'feat-3',
    title: '海量片库 每日更新',
    description: '收录超过两万部电影和电视剧全集，涵盖动作、喜剧、悬疑、爱情、科幻等全品类。专业内容团队每日更新，院线新片下线后第一时间上线高清版本。',
    icon: 'ri-database-2-line',
  },
];

export const heroStats = [
  { label: '收录影片', value: '20,000+' },
  { label: '每日更新', value: '50+部' },
  { label: '覆盖品类', value: '20+类' },
];